import { cn } from '@shadcn/lib/utils';
import React from 'react';

const headerStyles = {
  h1: 'h1-style',
  h2: 'h2-style',
  h3: 'h3-style',
  h4: 'h4-style',
  h5: 'h5-style',
} as const;

type HeaderLevels = keyof typeof headerStyles;

type HeaderProps = {
  readonly className?: string;
  readonly id?: string;
  readonly level: HeaderLevels;
  readonly children: React.ReactNode;
};

export function Header({ className, level, children, ...props }: HeaderProps) {
  const Level = level;
  return (
    <Level className={cn(headerStyles[level], className)} {...props}>
      {children}
    </Level>
  );
}

export type { HeaderLevels, HeaderProps };
